import { api } from "../base";
import type { IBookNotionalSeries } from "@pulse-ui/codegen-v2/generated_ts/market_data";

export type {
  IBookNotionalPoint,
  IBookNotionalSeries,
} from "@pulse-ui/codegen-v2/generated_ts/market_data";

// Served by trading-ops-server GET /api/trading-ops/v1/book-depth-series, which reads the
// historic captures l2-snapshot-store writes to S3. Times are RFC3339 or epoch millis.
export interface GetBookDepthSeriesParams {
  symbol: string;
  start_time: string;
  end_time: string;
  /** Per-side quote notional to walk each capture to, as a decimal string. */
  notional: string;
}

const bookDepthSeriesEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    getBookDepthSeries: build.query<
      IBookNotionalSeries,
      GetBookDepthSeriesParams
    >({
      query: (params) => ({
        url: "/api/trading-ops/v1/book-depth-series",
        params,
      }),
    }),
  }),
});

export const {
  useGetBookDepthSeriesQuery,
  useLazyGetBookDepthSeriesQuery,
} = bookDepthSeriesEndpoints;
